import React from "react";
import {
  TrainingCenterBundleItem,
  TrainingCenterCaregiverBundle,
} from "../../../system/AppState/AppStateTrainingCenter";
import { TrainingCenterLanguagePreference } from "../../TrainingCenter/TrainingCenterLanguageLookup";
import { convertBundleItemsToCourses } from "../../TrainingCenter/TrainingCenterUtils";
import TrainingCenterBundleCourse from "./TrainingCenterBundleCourse";
import TrainingCenterBundleItemCard from "./TrainingCenterBundleItemCard";

interface Props {
  bundle: TrainingCenterCaregiverBundle;
  languagePreference: TrainingCenterLanguagePreference;
  onClickBundleItem: (bundleItem: TrainingCenterBundleItem) => void;
}

const TrainingCenterBundleItemsList = (props: Props) => {
  const { courses, orphans } = convertBundleItemsToCourses(props.bundle.bundleItems);

  return (
    <div className="TrainingCenterBundleItemsList">
      <div className="orphans">
        {orphans.map((bundleItem) => (
          <TrainingCenterBundleItemCard
            key={`bundle-item-${bundleItem.bundleItemId}`}
            bundle={props.bundle}
            bundleItem={bundleItem}
            languagePreference={props.languagePreference}
            onClick={props.onClickBundleItem}
          />
        ))}
      </div>

      {courses.zipWithIndex().map(([course, i]) => (
        <TrainingCenterBundleCourse
          key={`course-${i}`}
          bundle={props.bundle}
          course={course}
          languagePreference={props.languagePreference}
          onClickBundleItem={props.onClickBundleItem}
        />
      ))}
    </div>
  );
};

export default TrainingCenterBundleItemsList;
